import { pipe, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { z } from 'zod';
import { dataAccessEnvironment } from '../models/data-access-environment';
import { StatusCode } from '../models/status-code';

function safeStringify(value: unknown) {
  try {
    return JSON.stringify(value);
  } catch (x) {
    return '';
  }
}

/**
 * Map errors to the Response type to simplify error handling downstream.
 *
 * This one is for AFTER getting the response body.
 *
 */
export function normalizeErrorReporting() {
  return pipe(
    catchError((error) => {
      if (error instanceof Response) {
        return throwError(() => error);
      }

      if (error instanceof z.ZodError) {
        if (dataAccessEnvironment.configuration.showZodErrorsInConsole) {
          console.error(error);
        }
        return throwError(
          () =>
            new Response(safeStringify(error.format()), {
              status: StatusCode.SchemaParseError,
              statusText: 'Schema Parse Error',
            })
        );
      }

      return throwError(
        () =>
          new Response(null, {
            status: StatusCode.UnknownError,
            statusText: 'Unknown Error',
          })
      );
    })
  );
}
